import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Calendar, Clock, ChevronUp, ChevronDown, Search, Plus } from 'lucide-react';
import '../components/SlotList.css'; // Assuming you have a CSS file for styling

const App = () => {
    return (
        <div className="bg-container">
            <SlotList />
        </div>
    );
};

const SlotList = () => {
    const [slots, setSlots] = useState([
        { id: 1, date: "2025-08-17", timeSlots: ["09:00 AM - 10:00 AM", "11:00 AM - 12:00 PM"] },
        { id: 2, date: "2025-08-18", timeSlots: ["02:00 PM - 03:00 PM", "04:00 PM - 05:00 PM", "05:00 PM - 06:00 PM"] },
        { id: 3, date: "2025-08-19", timeSlots: ["10:00 AM - 11:00 AM"] },
    ]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showEntries, setShowEntries] = useState(10);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    const handleShowEntriesChange = (e) => {
        setShowEntries(Number(e.target.value));
    };

    const filteredSlots = slots.filter(slot =>
        Object.values(slot).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const sortedSlots = [...filteredSlots].sort((a, b) => {
        if (sortConfig.key === null) return 0;
        const aValue = a[sortConfig.key];
        const bValue = b[sortConfig.key];

        if (aValue < bValue) {
            return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
            return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
    });

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return (
                <>
                    <ChevronUp size={12} className="sort-icon-default" />
                    <ChevronDown size={12} className="sort-icon-default" />
                </>
            );
        }
        if (sortConfig.direction === 'asc') {
            return <ChevronUp size={16} className="sort-icon-active" />;
        }
        return <ChevronDown size={16} className="sort-icon-active" />;
    };

    const getSlotBadges = (timeSlots) => {
        return timeSlots.map((slot, index) => (
            <span key={index} className="badge badge-slot">
                <Clock size={12} className="badge-icon" />
                {slot}
            </span>
        ));
    };

    return (
        <div className="main-container ml-desktop">
            <div className="header-section">
                <h1 className="main-title">Slot - List</h1>
                <div className="controls-group">
                    <button className="add-button">
                        <Plus size={16} />
                        Add New Slot
                    </button>
                </div>
            </div>
            <div className="controls-row">
                <div className="entries-control">
                    <span>Show</span>
                    <select
                        value={showEntries}
                        onChange={handleShowEntriesChange}
                        className="entries-select"
                    >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                    <span>entries</span>
                </div>
                <div className="search-control">
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="search-input"
                    />
                    <Search size={18} className="search-icon" />
                </div>
            </div>
            
            <div className="table-container desktop-only">
                <table className="slot-table">
                    <thead>
                        <tr>
                            {['S.No', 'Date', 'Slots'].map(header => (
                                <th
                                    key={header}
                                    scope="col"
                                    className="table-header-cell"
                                    onClick={() => requestSort(header.toLowerCase().replace('.', '').replace(' ', ''))}
                                >
                                    <div className="sortable-header">
                                        {header}
                                        <span className="sort-icon-container">
                                            {getSortIcon(header.toLowerCase().replace('.', '').replace(' ', ''))}
                                        </span>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sortedSlots.length > 0 ? (
                            sortedSlots.slice(0, showEntries).map((slot, index) => (
                                <tr key={slot.id} className="table-row">
                                    <td className="table-cell">{index + 1}</td>
                                    <td className="table-cell">
                                        <div className="cell-icon-text">
                                            <Calendar size={16} className="icon-main-color" />
                                            {slot.date}
                                        </div>
                                    </td>
                                    <td className="table-cell slots-cell">
                                        <div className="slot-badge-container">
                                            {getSlotBadges(slot.timeSlots)}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="table-cell text-center-none">
                                    No data available in table
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="card-container mobile-only">
                {sortedSlots.length > 0 ? (
                    sortedSlots.slice(0, showEntries).map((slot) => (
                        <div key={slot.id} className="slot-card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <Calendar size={16} className="icon-main-color" />
                                    {slot.date}
                                </h3>
                            </div>
                            <div className="card-body">
                                <div className="card-item">
                                    <span className="card-label">Time Slots:</span>
                                    <div className="slot-badge-container">
                                        {getSlotBadges(slot.timeSlots)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-results-message">
                        No slots found.
                    </div>
                )}
            </div>
        </div>
    );
};

export default App;